<div class="content">
    <div class="text-container">
        <h1 i18n>Email change failed</h1>
        <mat-icon>sentiment_very_dissatisfied</mat-icon>
        <p i18n class="info-text">This email adress may already be in use or recent authentication is needed and you need to log in again before retrying. </p>
        <button i18n class="info-text" (click)="dialogRef.close()">Ok</button>
    </div>
</div>